import { DataField, DataListField } from '@ncg/data';

export const fieldById = <T extends DataField | DataListField>(fields?: T[] | null, id?: DataField['fieldTypeId']): T | undefined => {
    if (!(fields && id)) {
        return;
    }
    return fields.find((field) => field.fieldTypeId === id);
};
